import { useCallback } from "react";

export const useCookie = () => {
  const getCookie = useCallback((key: string) => {
    const name = key + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const decodeCookie = decodedCookie.split(";");
    for (let i = 0; i < decodeCookie.length; i++) {
      let decodeKey = decodeCookie[i];
      while (decodeKey.charAt(0) === " ") {
        decodeKey = decodeKey.substring(1);
      }
      if (decodeKey.indexOf(name) === 0) {
        return decodeKey.substring(name.length, decodeKey.length);
      }
    }
    return "";
  }, []);

  const get = useCallback(
    (key: string) => {
      try {
        let localData = getCookie(key);
        if (localData) {
          try {
            localData = JSON.parse(localData);
          } catch (err) {
            // do nothing
          }
        }
        return localData;
      } catch (err) {
        return null;
      }
    },
    [getCookie]
  );

  const set = useCallback(
    (key: string, value: any) => {
      try {
        const localData: any = get(key);
        let localValue = {
          ...localData,
          ...value,
        };
        if (typeof value === "object") {
          localValue = JSON.stringify(localValue);
        }

        const exdays = 30;
        const newDate = new Date();
        newDate.setTime(newDate.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + newDate.toUTCString();
        document.cookie = key + "=" + localValue + ";" + expires + ";path=/";
        // localStorage.setItem(key, localValue);
      } catch (err) {
        // do nothing
      }
    },
    [get]
  );

  const deleteCookie = useCallback(
    (key: string) => {
      try {
        const localData = getCookie(key);
        if (localData) {
          try {
            document.cookie =
              key + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
          } catch (err) {
            // do nothing
          }
        }
      } catch (err) {
        // do nothing
      }
    },
    [getCookie]
  );
  return { get, set, deleteCookie };
};
